import { makeStyles } from "@material-ui/core";

const useChipsStyles = makeStyles({
  root: {
    height: 22,
    borderRadius: 2,
    margin: "1px 2px 1px 1px",
    fontSize: "1rem",
  },
});

export default useChipsStyles;
